import { Link } from 'react-router-dom'
import { css } from './css'
import logoLeao from '../../assets/logo-leao.png'

type Pagina = 'home' | 'precos' | 'duvidas' | 'pluggy' | 'app' | 'contato' | 'cookies'

const NAV_LINK = css('color: #A8B0C3; font-size: 15px; font-weight: 500; text-decoration: none;')
const NAV_LINK_ATIVO = { ...NAV_LINK, color: '#FFFFFF' }

export function Header({ atual }: { atual: Pagina }) {
  const linkStyle = (pagina: Pagina) => (pagina === atual ? NAV_LINK_ATIVO : NAV_LINK)

  return (
    <div style={css('width: 100%;')}>
      <div style={css('width: 100%; box-sizing: border-box; background: #17233A; padding: 8px 32px; display: flex; align-items: center; justify-content: center; gap: 8px;')}>
        <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="#F5A623" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
          <path d="M12 3 2 20h20L12 3Z" /><path d="M12 9v5M12 17h.01" />
        </svg>
        <span style={css('color: #DCE1EC; font-size: 12.5px;')}>
          O Walleon está em fase de homologação. Encontrou algo estranho?{' '}
          <Link to="/contato" style={css('color: #F5A623; font-weight: 600; text-decoration: none;')}>nos avise</Link>.
        </span>
      </div>
      <div style={css('width: 100%; box-sizing: border-box; background: #0B1220; border-bottom: 1px solid rgba(255,255,255,0.08); position: sticky; top: 0; z-index: 40;')}>
        <div style={css('max-width: 1200px; margin: 0 auto; padding: 18px 32px; display: flex; align-items: center; gap: 40px;')}>
          <Link to="/" style={css('display: flex; align-items: center; gap: 10px; text-decoration: none;')}>
            <img src={logoLeao} alt="" style={css('height: 32px; width: auto;')} />
            <span style={css('color: #FFFFFF; font-size: 18px; font-weight: 800; letter-spacing: 0.5px;')}>WALLEON</span>
          </Link>
          <div style={css('display: flex; align-items: center; gap: 28px; flex-grow: 1;')}>
            <Link to="/#produto" style={linkStyle('home')}>Produto</Link>
            <Link to="/precos" style={linkStyle('precos')}>Preços</Link>
            <Link to="/duvidas" style={linkStyle('duvidas')}>Dúvidas e tutoriais</Link>
            <Link to="/conectar-bancos" style={linkStyle('pluggy')}>Conectar bancos</Link>
            <Link to="/baixar-app" style={linkStyle('app')}>Aplicativo</Link>
            <Link to="/contato" style={linkStyle('contato')}>Contato</Link>
          </div>
          <Link to="/" style={css('background: #F5A623; color: #0B1220; font-weight: 700; font-size: 14px; padding: 10px 22px; border-radius: 8px; text-decoration: none;')}>Entrar</Link>
        </div>
      </div>
    </div>
  )
}
